/* eslint-disable react/prop-types */
import React, { useRef, useState, useEffect } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CircularProgress from '@mui/material/CircularProgress';
import Slider from "react-slick";
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from './Dialog';
import DialogContent from '@mui/material/DialogContent';

import IconButton from '@mui/material/IconButton';

import Typography from '@mui/material/Typography';

import Toolbar from '@mui/material/Toolbar';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import DownloadIcon from '@mui/icons-material/Download';

import ImageViewer from "./ImageViewer";
import isEqual from "lodash/isEqual";
import ReactPlayer from 'react-player'

import DefaultContext from "./auth/Context";
import Image from "./Image";

const VIDEO_THUMBNAIL_PLACEHOLDER = 'https://placehold.co/60x40/333/ccc?text=Video';
const YOUTUBE_THUMBNAIL_PLACEHOLDER = 'https://placehold.co/60x40/c4302b/white?text=YT';
const DOC_THUMBNAIL_PLACEHOLDER = 'https://placehold.co/600x400/2196f3/white?text=TAI+LIEU';

// Hàm helper để tạo URL xem tài liệu qua MS Office Viewer
const getDocumentViewerUrl = (url) => {
    const docUrl = `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
    //console.log(docUrl);
    return docUrl;
    
};
const DocumentOverlay = ({ fileName }) => (
    <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer'
    }}>
        {/* Icon ở giữa */}
        <div style={{
            background: 'rgba(0,0,0,0.5)',
            borderRadius: '50%',
            padding: '15px',
            display: 'flex',
            marginBottom: '10px'
        }}>
            <svg viewBox="0 0 24 24" width="40" height="40" fill="white">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
            </svg>
        </div>

        {/* Tên file ở dưới cùng */}
        <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            background: 'linear-gradient(to top, rgba(0,0,0,0.9), transparent)', // Gradient đen mờ
            padding: '20px 10px 10px 10px',
            color: '#fff',
            textAlign: 'center'
        }}>
            <div style={{
                fontSize: '14px',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis', // Cắt chữ ... nếu tên quá dài
                width: '100%'
            }} title={fileName}>
                {fileName}
            </div>
        </div>
    </div>
);
// Hàm kiểm tra xem một url có phải là document không (dùng cho Dialog)
const isDocumentUrl = (url) => {
    if (!url) return false;
    const cleanUrl = url.split('?')[0].toLowerCase();
    const extensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
    return extensions.some(ext => cleanUrl.endsWith('.' + ext));
}

const CustomPlayIcon = () => (
    <div className="custom-play-icon-wrapper">
        <svg viewBox="0 0 24 24" width="64" height="64" fill="white">
            <path d="M8 5v14l11-7z" />
        </svg>
    </div>
);

function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block", background: "#dddddd" }}
            onClick={onClick}
        >
        </div>
    );
}
function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block", background: "#dddddd" }}
            onClick={onClick}
        >
        </div>
    );
}

function MySlide({ slidesToShow, arrows, files, dotImage, imageMode, onView, itemStyle, mediaStyle, playerContainerStyle }) {
    const sliderRef = useRef(null);
    const playerRefs = useRef([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [playingVideoIndex, setPlayingVideoIndex] = useState(null);
    const [playerKeys, setPlayerKeys] = useState({});

    useEffect(() => {
        playerRefs.current = playerRefs.current.slice(0, files.length);
    }, [files.length]);

    slidesToShow = slidesToShow || 3;
    
    let properties = {
        infinite: true,
        lazyLoad: true,
        dots: true,
        speed: 500,
        initialSlide: 0,
        arrows: arrows || false,
        slidesToShow: (files.length >= slidesToShow ? slidesToShow : files.length),
        slidesToScroll: (files.length >= slidesToShow ? slidesToShow : files.length),
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: (files.length >= slidesToShow ? slidesToShow : files.length),
                    slidesToScroll: (files.length >= slidesToShow ? slidesToShow : files.length),
                }
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
        autoplay: false,
        afterChange: (newIndex) => {
            setCurrentSlide(newIndex);
        },
        beforeChange: (oldIndex, newIndex) => {
            setPlayingVideoIndex(null);
        },
    };

    if (dotImage) {
        properties.customPaging = function (i) {
            const file = files[i];
            let thumbSrc;
            if (file.type === 'video') {
                thumbSrc = file.file?.thumbnail ? `${file.url}&thumbnail=1` : VIDEO_THUMBNAIL_PLACEHOLDER;
            } else if (file.type === 'youtube') {
                thumbSrc = YOUTUBE_THUMBNAIL_PLACEHOLDER;
            } else if (file.type === 'document') {
                // Hiển thị thumbnail mặc định cho document
                thumbSrc = DOC_THUMBNAIL_PLACEHOLDER;
            } else {
                thumbSrc = `${file.url}&size=X`;
            }
            return (
                <a style={{ display: 'block', width: '100%', height: '100%' }}>
                    <img
                        src={thumbSrc}
                        alt="thumbnail"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '4px'
                        }}
                    />
                </a>
            );
        }
        properties.dotsClass = "slick-dots slick-thumb"
    } else {
        properties.dotsClass = "slick-dots"
    }

    return (
        <Slider {...properties}>
            {files.map((file, index) => {
                return (
                    <div key={file._id} style={itemStyle}>
                        {(file.type === "video" || file.type === "youtube") ?
                            <div style={playerContainerStyle} onClick={() => {
                                if (playingVideoIndex === index) {
                                    setPlayingVideoIndex(null)
                                } else {
                                    setPlayingVideoIndex(index)
                                }
                            }}>
                                <ReactPlayer
                                    key={`${file.url}-${playerKeys[index] || 0}`}
                                    ref={el => playerRefs.current[index] = el}
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                    }}
                                    url={file.url}
                                    playing={playingVideoIndex === index}
                                    controls={true}
                                    light={file.poster || true}
                                    playIcon={<CustomPlayIcon />}
                                    width="100%"
                                    height="100%"
                                    playsinline={true}
                                    config={{
                                        youtube: {
                                            playerVars: {
                                                showinfo: 0,
                                                modestbranding: 1,
                                                rel: 0,
                                                iv_load_policy: 3
                                            }
                                        }
                                    }}
                                    onPause={() => {
                                        if (playingVideoIndex === index) { setPlayingVideoIndex(null); }
                                        setPlayerKeys(prevKeys => ({
                                            ...prevKeys,
                                            [index]: (prevKeys[index] || 0) + 1
                                        }));
                                    }}
                                    onEnded={() => {
                                        if (playingVideoIndex === index) {
                                            setPlayingVideoIndex(null);
                                        }
                                        setPlayerKeys(prevKeys => ({
                                            ...prevKeys,
                                            [index]: (prevKeys[index] || 0) + 1
                                        }));
                                    }}
                                    onError={e => console.error(`ReactPlayer Error for ${file.url}:`, e)}
                                />
                            </div>
                            : file.type === "document" ?
                                // XỬ LÝ HIỂN THỊ DOCUMENT (PDF, DOCX, XLSX)
                                <div 
                                    style={{...playerContainerStyle, position: 'relative', background: '#f5f5f5', cursor: 'pointer'}}
                                    onClick={() => onView ? onView(file.url, index) : undefined}
                                >
                                    <img 
                                        src={DOC_THUMBNAIL_PLACEHOLDER}
                                        style={{width: '100%', height: '100%', objectFit: 'cover', opacity: 0.9}}
                                        alt="Document Placeholder"
                                    />
                                    {/* Component hiển thị tên và icon */}
                                    <DocumentOverlay fileName={file.file?.originalname || "Tài liệu"} />
                                </div>
                            :
                                // XỬ LÝ HIỂN THỊ ẢNH
                                <Image style={mediaStyle} src={file.url + '&size=L'} mode={imageMode || "fill"} onClick={() => onView ? onView(file.url + '&size=FULL', index) : undefined} />
                        }
                    </div>
                )
            })}
        </Slider>
    )
}

class SlideFile extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            imageUrl: null, // Biến này lưu URL đang xem (ảnh hoặc doc)
            load: 0,
            loading: false,
            viewType: 'image' // image | document
        }
        this.view = this.view.bind(this);
        this.closeViewer = this.closeViewer.bind(this);
    }
    async componentDidMount() {
        this.loadFile();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.idLink !== this.props.idLink || prevProps.idLinkRef !== this.props.idLinkRef || !isEqual(prevProps.images, this.props.images)) {
            this.loadFile();
        }
    }
    async loadFile() {
        let condition = this.props.condition || {};
        let token = (this.context.userInfo || {}).token || this.context.config.public_token;
        let files = [];
        if (this.props.idLink || this.props.idLinkRef) {
            if (this.props.idLink) files = await this.context.apis.asyncFiles(token, this.props.idLink, condition.id_app || this.context.config.id_app, condition, 0);
            if (this.props.idLinkRef) files = [...files, ...(await this.context.apis.asyncFiles(token, this.props.idLinkRef, condition.id_app || this.context.config.id_app, condition, 0))];

            files.forEach(file => {
                if (file?.file?.url) {
                    file.url = file?.file?.url;
                    //convert from private url to public url
                    if (file.url.indexOf("youtu.be") >= 0) {
                        let id_youtube = file.url.split("/").pop();
                        file.url = `https://www.youtube.com/watch?v=${id_youtube}`;
                    }
                } else {
                    if (file._id && !file.url) {
                        file.url = `${this.context.config.server_url_report}/api/${condition.id_app || this.context.config.id_app}/file/download/${file._id}?access_token=${token}`;
                    }
                    if (file.url.indexOf("?") < 0) file.url = file.url + "?i"
                }
            })
            if (files.length === 0 && this.props.defaultImage) {
                // Tạo ảnh default...
                for(let i=0; i<3; i++){
                    files.push({
                        _id: 'default'+i,
                        url: '/images/' + this.props.defaultImage + "?i"
                    })
                }
            }
        }
        if (this.props.images) {
            let images = this.props.images.filter(m => m && m.indexOf("getfile/others/noimage.png") < 0).map(m => {
                return {
                    url: (m.indexOf("http") === 0 ? m : `${this.context.config.server_url_report}${m}?access_token=${token}`)
                }
            })
            files = files.concat(images);
        }

        files.forEach(file => {
            const ext = (file.file?.extension || "").toLowerCase();
            const url = (file.url || "").toLowerCase();

            if (["mp4", "mov", "avi"].includes(ext)) {
                file.type = "video"
                file.poster = file.file?.thumbnail ? file.url + "&thumbnail=1" : undefined
            } else if (file.file?.url?.indexOf("youtu") >= 0 || url.indexOf("youtu") >= 0) {
                file.type = "youtube";
            } else if (["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(ext)) {
                // --- UPDATE: PHÁT HIỆN DOCUMENT ---
                file.type = "document";
            } else {
                file.type = "image"
            }
        })

        this.setState({
            files: files,
            load: this.state.load + 1
        })
    }

    view(url, initialSlide) {
        // Kiểm tra xem URL được click là ảnh hay document
        const isDoc = isDocumentUrl(url) || (this.state.files && this.state.files[initialSlide] && this.state.files[initialSlide].type === 'document');
        
        // Nếu là document, dùng URL gốc (bỏ tham số &size=L nếu có) để viewer đọc được
        let finalUrl = url;
        if(isDoc) {
             finalUrl = url.replace('&size=L', '').replace('&size=S', '');
        }
        let fileName = (this.state.files||[])[initialSlide]?.file?.originalname || "Tài liệu";

        this.setState({ 
            imageUrl: finalUrl, 
            viewType: isDoc ? 'document' : 'image',
            initialSlide,
            fileName,
            load: this.state.load + 1,
            loading: true
        },()=>{
          if(this.refViewer){
              this.refViewer.open();
          }
        });
    }

    closeViewer(){
        if(this.refViewer){
            this.refViewer.close();
        }
    }

    render() {
        if (!this.state.files || this.state.files.length === 0) return null;
        let height = this.props.height || 250;
        
        // Render dạng Grid (Thumbnail nhỏ)
        if (this.props.grid) {
            return (
                <Grid container>
                    {this.state.files.map(file => {
                        return (
                            <Grid key={file._id} style={{ padding: 10 }} size={3}>
                                {/* Nếu là doc thì mở link tab mới hoặc dialog, ở đây để href cơ bản */}
                                <a href={file.url} target="_blank" rel="noreferrer">
                                    {file.type === 'document' 
                                        ? <img src={DOC_THUMBNAIL_PLACEHOLDER} height={height/3} style={{objectFit:'cover', width:'100%'}} alt="doc"/>
                                        : <Image height={height / 3} src={file.url + '&size=S'} mode='fill' alt={this.props.title} />
                                    }
                                </a>
                            </Grid>
                        );
                    })}
                </Grid>
            );
        }

        let files = this.state.files;
        if (files.length === 1) {
            files.push(files[0]) // Hack để slider chạy mượt nếu chỉ có 1 item
        }
         const {formHeaderColor,mainTextColor} = this.context.config;

        return (
            <div
                style={{ height: height, ...(this.props.style || {}) }}
            >
                <MySlide
                    itemStyle={{
                        height,
                        outline: "none",
                        position: "relative",
                        backgroundColor: "#f0f0f0",
                        borderRadius: 6,
                        overflow: "hidden"
                    }}
                    mediaStyle={{
                        width: "100%",
                        height: height - 60,
                        maxHeight: height - 60,
                        objectFit: "cover",
                        display: "block",
                        margin: "0 auto",
                        backgroundColor: "#000",
                        overflow: "hidden"
                    }}
                    playerContainerStyle={{
                        position: "relative",
                        height: height - 60,
                        maxHeight: height - 60,
                        width: "100%",
                        backgroundColor: "#000",
                        display: 'flex',
                        alignItems: "center",
                        overflow: "hidden",
                        justifyContent: "center"
                    }}

                    slidesToShow={this.props.slidesToShow}
                    arrows={this.props.arrows}
                    files={this.state.files}
                    dotImage={this.props.dotImage}
                    imageMode={this.props.mode}
                    onView={this.view}
                />
                
                {/* DIALOG HIỂN THỊ FULL MÀN HÌNH */}
                <Dialog
                    ref={ref=>this.refViewer = ref}
                    fullScreen={true}
                    fullWidth={true}
                    maxWidth={'lg'}
                    //open={!!this.state.imageUrl}
                    //onClose={() => this.setState({ imageUrl: null, load: this.state.load + 1 })}
                    renderTitle ={()=>{
                      return <Toolbar sx={{ backgroundColor:formHeaderColor,color:mainTextColor,pt: 'env(safe-area-inset-top)',px: 1 }}>
                                <IconButton onClick={this.closeViewer} edge="start">
                                <ArrowBackIosNewIcon fontSize="small" style={{color:mainTextColor}} />
                                </IconButton>
                                <Typography variant="h6" noWrap fontWeight="bold" sx={{ flexGrow: 1, textAlign: 'center', pr: 4 }}>
                                {this.state.fileName}
                                </Typography>

                                <IconButton  edge="start" onClick={()=>{
                                this.context.apis.downloadFile(this.state.imageUrl + "&action=download",this.state.fileName);
                                }}>
                                <DownloadIcon fontSize="small" style={{color:mainTextColor}}/>
                                </IconButton>
                            </Toolbar>
                      }}
                  >
                    <DialogContent sx={{ display: 'flex', flexDirection: "column", p: 0, overflow: "hidden", height: '100%', background: '#f5f5f5'}}>
                        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column", position: 'relative' }}>
                            {!!this.state.imageUrl && (
                                this.state.viewType === 'document' ? (
                                    <div style={{width: '100%', height: '100%', position: 'relative'}}>
                                        {/* LOADING INDICATOR */}
                                        {this.state.loading && (
                                            <div style={{
                                                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                                background: '#fff', zIndex: 2
                                            }}>
                                                <CircularProgress />
                                            </div>
                                        )}
                                        
                                        {/* IFRAME DOCUMENT */}
                                        <iframe 
                                            src={getDocumentViewerUrl(this.state.imageUrl)}
                                            style={{width: '100%', height: '100%', border: 'none'}}
                                            title="Full Document Viewer"
                                            // Ẩn loading khi iframe load xong
                                            onLoad={() => this.setState({ loading: false })}
                                        />
                                        <div style={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            width: '60px',   // Đủ rộng để che nút
                                            height: '85px',  // Đủ cao để che thanh toolbar chỗ đó
                                            backgroundColor: "transparent", // Khớp với màu nền toolbar của Google Docs Viewer
                                            zIndex: 1999990,
                                            cursor: 'default' // Đổi trỏ chuột để người dùng không nghĩ đây là nút bấm được
                                        }} />
                                    </div>
                                ) : (
                                    <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', overflow:'auto'}}>
                                         <ImageViewer src={this.state.imageUrl}/>
                                    </div>
                                )
                            )}
                        </div>

                        {/*<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 10, background: '#fff', borderTop: '1px solid #ddd' }}>
                            <Button size="large" color="secondary" variant="contained" onClick={() => this.setState({ imageUrl: null, load: this.state.load + 1 })}>{this.context.apis.getLabel("Quay lại")}</Button>
                            {this.state.viewType === 'document' && 
                                <Button style={{marginLeft: 10}} size="large" color="primary" variant="outlined" component="a" href={this.state.imageUrl} target="_blank">Tải xuống</Button>
                            }
                        </div>*/}
                    </DialogContent>
                </Dialog>
            </div>
        )
    }
}
SlideFile.contextType = DefaultContext;
export default SlideFile;